import { Badge } from '@purpur/library';
import styled from 'styled-components';

export const StyledMenuItemBadge = styled(Badge)`
    white-space: nowrap;
`;
